<template>
  <p
      v-if="expirationText"
      :class="[
        'branded-image-expiration',
        { ['branded-image-expiration__expires-soon']: this.expiresSoon },
        { ['branded-image-expiration__expires-today']: this.expiresToday }]">
    {{expirationText}}
  </p>
</template>

<script>
  import { differenceInDays } from "date-fns"
  import { mapState } from 'vuex'
  import { utcToZonedTime } from "date-fns-tz"

  export default {
    props: {
      sendAtEnd: String,
    },

    name: 'AdExpirationWarning',

    computed: {
      expirationText: function () {
        if (this.expiresToday) { return 'expires today' }
        if (this.expiresSoon) { return 'expires soon' }
      },

      expiresSoon: function () {
        const merchantDateTime = utcToZonedTime(new Date(), this.currentMerchant.merchant_time_zone),
              daysTilExpiration = differenceInDays(this.endDateInMerchantZone, merchantDateTime)
        return daysTilExpiration > 0 && daysTilExpiration < 6
      },

      expiresToday: function () {
        const merchantDateTime = utcToZonedTime(new Date(), this.currentMerchant.merchant_time_zone)
        return differenceInDays(this.endDateInMerchantZone, merchantDateTime) === 0
      },

      endDateInMerchantZone() {
        return utcToZonedTime(this.sendAtEnd, this.currentMerchant.merchant_time_zone)
      },

      ...mapState([
        'currentMerchant'
      ])
    }
  }
</script>
